import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Form, Button, Alert, Spinner } from 'react-bootstrap'
import api from '../services/api'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      await api.post('/auth/forgot-password', { email })
      setSuccess(true)
    } catch (err: unknown) {
      const error = err as { response?: { data?: { detail?: string } } }
      setError(error.response?.data?.detail || 'Ein Fehler ist aufgetreten')
    } finally {
      setLoading(false)
    }
  }

  if (success) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-logo">
            <i className="bi bi-envelope-check text-success"></i>
            <h2 className="mt-3">E-Mail gesendet</h2>
          </div>

          <Alert variant="success">
            Falls ein Konto mit dieser E-Mail-Adresse existiert, wurde ein Link zum Zurücksetzen des Passworts gesendet.
          </Alert>

          <p className="text-muted text-center mb-4">
            Bitte überprüfen Sie Ihren Posteingang und ggf. auch den Spam-Ordner.
          </p>

          <Link to="/login" className="btn btn-outline-primary w-100">
            <i className="bi bi-arrow-left me-2"></i>
            Zurück zur Anmeldung
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <i className="bi bi-key"></i>
          <h2 className="mt-3">Passwort vergessen</h2>
          <p className="text-muted">Geben Sie Ihre E-Mail-Adresse ein</p>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-4">
            <Form.Label>E-Mail-Adresse</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ihre.email@beispiel.de"
              required
              autoFocus
            />
            <Form.Text className="text-muted">
              Wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.
            </Form.Text>
          </Form.Group>

          <Button
            variant="primary"
            type="submit"
            className="w-100 mb-3"
            disabled={loading || !email}
          >
            {loading ? (
              <>
                <Spinner size="sm" className="me-2" />
                Wird gesendet...
              </>
            ) : (
              <>
                <i className="bi bi-send me-2"></i>
                Link anfordern
              </>
            )}
          </Button>

          <Link to="/login" className="btn btn-outline-secondary w-100">
            <i className="bi bi-arrow-left me-2"></i>
            Zurück zur Anmeldung
          </Link>
        </Form>
      </div>
    </div>
  )
}
